import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, EmptyState, Icon } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { PathNames } from 'constants/General'

export const WalletNotFound = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleRedirectToWalletList = () => {
    navigate(`${PathNames.WALLETS}${PathNames.WALLET_DASHBOARD}`)
  }

  return (
    <EmptyState
      testId="empty-state"
      LottiePlayer={<Lottie src="no-data" />}
      title={t('walletNotFound')}
      PrimaryButton={
        <Button onClick={handleRedirectToWalletList} iconElement={<Icon name="ArrowUUpLeft" />}>
          {t('return')}
        </Button>
      }
    />
  )
}
